import { useState } from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  Button,
  Box,
  Image,
  Stack,
  Skeleton,
  Text
} from '@chakra-ui/react'
import { COLORS } from 'utils/styles'
import { ImagesPng } from 'assets/images'
import {
  getPosts,
  setBlogRepostData,
  setBlogRepostParent,
  setChosenNotifBlog,
  setCloseAllDrawers,
  setOpenPopupBlogs,
  setPosts,
  usersSelectors
} from 'store'
import { PENDING } from 'utils/constants'
import {
  isNowGreaterOrEqual,
  postTypeStatus
} from 'utils/helpers'
import { TextEditorReader } from 'components/UserSection/ProfileBlog/BlogList/TextEditorReader'
import { TextAnimation } from 'components/UserSection/ProfileBlog/BlogList/TextAnimation'

export const BlogPreview = ({
  from,
  item,
  blogParent,
  selectedUser = {},
  widen = false,
  GoToMarker,
  finishAnimation = false
}) => {
  const dispatch = useDispatch()
  const {
    activeProfile,
    blogRepostData,
    getPostsStatus,
    postsOption
  } = useSelector(usersSelectors)
  const [loadedProfileImage, setLoadedProfileImage] = useState({})

  const handleProfileImage = (postId) => {
    setTimeout(() => {
      setLoadedProfileImage((prev) => ({
        ...prev,
        [postId]: true
      }))
    }, 500)
  }

  return item
    && Object.keys(item).length
    && !item.is_archived
    && (
      !item?.is_planned
      || (
        item?.is_planned
        && isNowGreaterOrEqual(item?.planned_at)
      )
    ) ? (
      <Stack
        width="100%"
        backgroundColor={COLORS.white}
        border={from === 'editForm' ? '' : `solid 2px ${COLORS.gold}`}
        borderRadius="5px"
        borderTop="none"
        marginTop={from === 'editForm' ? '0' : '5px'}
        padding="10px"
        display="flex"
        justifyContent="flex-start"
        gap="1rem"
        pos="relative"
      >
        <Stack
          top="-24px"
          margin="-10px -10px -20px -10px"
          padding="5px 5px 0px 5px"
          border={from === 'editForm' ? '' : `solid 2px ${COLORS.gold}`}
          borderLeft={from === 'editForm' ? 'auto' : 'none'}
          borderRight={from === 'editForm' ? 'auto' : 'none'}
          borderBottom="none"
          borderTopRadius="5px"
          pointerEvents={from === 'editForm' ? 'none' : 'auto'}
        >
          <Stack
            alignItems="center"
            display="inline"
            width="auto"
            justifyContent="flex-start"
          >
            <Skeleton
              isLoaded={loadedProfileImage[item?.id]}
              fadeDuration={1}
              boxSize="55px"
              position="relative"
              objectFit="cover"
              borderRadius="full"
              display="inline-flex"
              verticalAlign="bottom"
              sx={{
                '@media (max-width: 473px)': {
                  boxSize: '50px'
                }
              }}
            >
              <Image
                src={
                  item?.profile_picture
                  ?? selectedUser?.profile_picture
                  ?? ImagesPng.DefaultImage
                }
                alt="User Image"
                borderRadius="full"
                cursor={item?.coordinates && item?.coordinates.length ? 'pointer' : 'pointer'}
                onClick={() => {
                  if (item?.coordinates && item?.coordinates.length) {
                    localStorage.setItem('isRequestModalOpen', 'false')
                    GoToMarker(item, widen)
                  }
                }}
                onLoad={() => handleProfileImage(item?.id)}
              />
            </Skeleton>
            <Text
              top="6px"
              left="65px"
              position="absolute"
              fontSize="16px"
              lineHeight="28px"
              maxWidth={from === 'blogListFromBlogModal' && !widen ? '180px' : ''}
              textOverflow="ellipsis"
              overflow="hidden"
              whiteSpace="nowrap"
              sx={{
                '@media (max-width: 473px)': {
                  ...(postsOption.type === 'marker'
                    ? {
                      fontSize: '14px',
                      lineHeight: '25px'
                    } : ''
                  ),
                  lineHeight: '25px'
                }
              }}
            >
              <Box display="contents">
                { item?.full_name ?? selectedUser?.full_name }
              </Box>
              <br />
              <Box letterSpacing="-1px">
                {
                  postTypeStatus(
                    blogParent.length > 1 ? blogParent.at(-1) : item,
                    true
                  )
                }
              </Box>
            </Text>
          </Stack>

          <Button
            onClick={() => {
              if (
                blogRepostData?.at(-1)?.id !== item.id
                && getPostsStatus !== PENDING
              ) {
                if (from === 'blogListFromBlogModal') {
                  const customPopupOverlay = document.querySelector('#custom-popup-overlay')

                  dispatch(setBlogRepostData([...blogRepostData, item]))

                  dispatch(setBlogRepostParent([]))
                  dispatch(getPosts({
                    type: 'single',
                    postId: item?.id,
                    id: selectedUser?.id ?? activeProfile?.id,
                    from: 'repost',
                    ...(customPopupOverlay ? { changeTo: 'marker' } : {})
                    // Changing to "marker" on state.postsOption is needed,
                    // since "marker" has a different set of css and data
                  }))
                } else {
                  dispatch(setCloseAllDrawers(true))

                  setTimeout(() => dispatch(setCloseAllDrawers(false)), 1350)
                  setTimeout(() => {
                    dispatch(setChosenNotifBlog([]))
                    dispatch(setPosts([]))
                    dispatch(getPosts({
                      type: 'single',
                      postId: item?.id,
                      id: selectedUser?.id
                    }))
                    dispatch(setOpenPopupBlogs(true))
                  }, 1650)
                }
              }
            }}
            display={from === 'editForm' ? 'none' : 'flex'}
            position="absolute"
            wordBreak="break-word"
            whiteSpace="normal"
            right="0"
            width="90px"
            height="50px"
            fontSize="16px"
            fontWeight="400"
            margin="2px 5px 5px 5px"
            boxShadow="0 2px 2px rgba(0, 0, 0, 0.2)"
            backgroundColor={COLORS.gold}
            _hover={{ background: COLORS.gold_hover }}
            sx={{
              '@media (max-width: 473px)': {
                ...(postsOption.type === 'marker'
                  ? {
                    fontSize: '14px',
                    height: '40px',
                    width: '85px',
                    top: '10px'
                  } : {
                    fontSize: '15px',
                    height: '45px',
                    width: '90px',
                    top: '7.5px'
                  }
                )
              }
            }}
          >
            Original Article
          </Button>

          <Stack
            display="flex"
            justifyContent="center"
            direction="row"
          >
            <Button
              background="transparent"
              border="solid 1px black"
              padding="2px 0"
              fontSize={widen ? '23px' : '19px'}
              transition="font-size 0.8s ease"
              width="100%"
              borderRadius="5px"
              align="center"
              letterSpacing=".15px"
              fontWeight="400"
              display="block"
              overflow="hidden"
              pointerEvents="none"
            >
              <TextAnimation
                item={item}
                blogParent={blogParent}
                widen={widen}
                place={from === 'blogListFromBlogModal' ? '' : 'profile-panel'}
                finishAnimation={finishAnimation}
              />
            </Button>
          </Stack>

          <Stack
            direction="row"
            justifyContent="center"
            margin="-2.5px 0"
            display="flex"
          >
            {
              item?.affinities.length
                ? item?.affinities.map((e) => (
                  <Box
                    border="solid 1px black"
                    borderRadius="5px"
                    p="0 2px"
                    data-name="blog-affinity"
                    fontSize={widen ? '15px' : '11px'}
                    transition="font-size 0.8s"
                    margin="2.5px 0"
                    overflow="hidden"
                  >
                    {e.title}
                  </Box>
                ))
                : (
                  <Box
                    border="solid 1px black"
                    borderRadius="5px"
                    p="0 2px"
                    data-name="blog-affinity"
                    fontSize={widen ? '15px' : '11px'}
                    transition="font-size 0.8s"
                    overflow="hidden"
                  >
                    No Affinities
                  </Box>
                )
            }
          </Stack>
        </Stack>

        <Box
          className="article-body"
          display="grid"
          sx={{
            '& > *': {
              gridArea: '1 / 1',
              minWidth: 0,
              objectFit: 'contain'
            }
          }}
        >
          <Stack
            width="calc(100% + 20px)"
            marginLeft="-10px"
            marginBottom="-10px"
            padding="0 5px 15px 5px"
            display="grid"
          >
            <Stack
              width="100%"
              display="block"
              overflow="hidden"
            >
              <TextEditorReader
                dispatch={dispatch}
                item={item}
                setCloseAllDrawers={setCloseAllDrawers}
                widen={widen}
              />
            </Stack>
          </Stack>
        </Box>
      </Stack>
    ) : (
      <Text
        width="100%"
        backgroundColor={COLORS.white}
        border={`solid 2px ${COLORS.gold}`}
        borderRadius="5px"
        padding="10px"
        textAlign="center"
      >
        Reposted post was removed or unavailable
      </Text>
    )
}
